import { dataLayerPublish } from '@dhl/datalayer'
import { type UserDto } from '@dhl/receiver-user-service-api'

import { getConfig } from './config'
import { getSignedInPath, REFERRER } from './useReferrer'

const redirect = (url: string) => {
  // @ts-expect-error
  window.setLocationHref(url)
}

export const redirectUser = (user: UserDto) => {
  const storedReferrer = getSignedInPath()
  const { userType } = user
  const {
    features: {
      signIn: { redirectUrl },
    },
  } = getConfig()

  const isBusinessUser = userType === 'business' || userType === 'accountManager' || userType === 'terminal'
  if (storedReferrer && !isBusinessUser) {
    // eslint-disable-next-line n/no-unsupported-features/node-builtins -- this is a browser environment
    localStorage.removeItem(REFERRER)
    redirect(storedReferrer)
  } else {
    switch (userType) {
      case 'business':
      case 'accountManager':
      case 'terminal':
        redirect(`/business/${window.location.hash}`)
        break
      case 'parcelShop':
        if (
          user.parcelShopServices &&
          ['spa', 'firstmile', 'lastmile', 'selfservice'].some((service) => user.parcelShopServices?.includes(service))
        ) {
          if ((user.roles ?? []).indexOf('ServicepointSelfScan') >= 0) {
            redirect('/servicepoint-self-scan/')
          } else {
            redirect('/servicepoint/')
          }
        } else {
          redirect('/otc/')
        }
        break
      case 'consumer':
        redirect(redirectUrl)
        break
      default:
        dataLayerPublish('ERROR', { message: `Could not redirect user for type: ${userType}` })
    }
  }
}
